import { useEffect, useState } from 'preact/hooks';

const API_URL = import.meta.env.VITE_API_URL || 'https://api.unplug-app.com';

export function SubscriptionSuccess() {
  const [loading, setLoading] = useState(true);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    // Fetch updated subscription status
    async function fetchSubscription() {
      try {
        const sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
          // Not logged in, redirect to home
          window.location.href = '/';
          return;
        }

        const res = await fetch(`${API_URL}/v3/subscription`, {
          headers: {
            'Authorization': `Bearer ${sessionId}`
          }
        });

        if (res.ok) {
          const data = await res.json();
          setSubscription(data);
        }
      } catch (err) {
        console.error('Failed to fetch subscription:', err);
      } finally {
        setLoading(false);
      }
    }

    // Small delay to allow webhook to process
    setTimeout(fetchSubscription, 2000);
  }, []);

  if (loading) {
    return (
      <div class="subscription-result-page">
        <div class="result-container">
          <div class="spinner" />
          <p>Confirming your subscription...</p>
        </div>
        <style>{styles}</style>
      </div>
    );
  }

  return (
    <div class="subscription-result-page success">
      <div class="result-container">
        <div class="result-icon success">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <h1>Welcome to Unplug Pro!</h1>

        <p class="result-message">
          Your subscription is now active. Thank you for choosing Unplug.
        </p>

        {subscription && (
          <div class="subscription-details">
            <div class="detail-row">
              <span class="label">Plan</span>
              <span class="value">{subscription.plan === 'business' ? 'Business' : 'Pro'}</span>
            </div>
            <div class="detail-row">
              <span class="label">Status</span>
              <span class="value status-active">Active</span>
            </div>
            {subscription.subscription_ends_at && (
              <div class="detail-row">
                <span class="label">Next billing</span>
                <span class="value">
                  {new Date(subscription.subscription_ends_at).toLocaleDateString('en-GB', {
                    day: 'numeric',
                    month: 'long',
                    year: 'numeric'
                  })}
                </span>
              </div>
            )}
          </div>
        )}

        <div class="result-actions">
          <a href="/" class="btn btn-primary">
            Go to Dashboard
          </a>
        </div>

        <p class="result-note">
          A confirmation email has been sent to your billing address.
        </p>
      </div>
      <style>{styles}</style>
    </div>
  );
}

const styles = `
  .subscription-result-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
    padding: 2rem;
  }

  .subscription-result-page.cancelled {
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  }

  .result-container {
    background: white;
    border-radius: 12px;
    padding: 3rem;
    max-width: 480px;
    width: 100%;
    text-align: center;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  }

  .result-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 1.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .result-icon.success {
    background: #dcfce7;
    color: #16a34a;
  }

  .result-icon.cancelled {
    background: #fee2e2;
    color: #dc2626;
  }

  .result-icon svg {
    width: 40px;
    height: 40px;
  }

  .subscription-result-page h1 {
    font-size: 1.75rem;
    color: #1e293b;
    margin-bottom: 1rem;
  }

  .result-message {
    font-size: 1.125rem;
    color: #64748b;
    margin-bottom: 2rem;
  }

  .subscription-details {
    background: #f8fafc;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 2rem;
    text-align: left;
  }

  .detail-row {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 0;
    border-bottom: 1px solid #e2e8f0;
  }

  .detail-row:last-child {
    border-bottom: none;
  }

  .detail-row .label {
    color: #64748b;
  }

  .detail-row .value {
    font-weight: 500;
    color: #1e293b;
  }

  .status-active {
    color: #16a34a !important;
  }

  .result-actions {
    margin-bottom: 1.5rem;
  }

  .btn {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    text-decoration: none;
    cursor: pointer;
    border: none;
    font-size: 1rem;
  }

  .btn-primary {
    background: #3b82f6;
    color: white;
  }

  .btn-primary:hover {
    background: #2563eb;
  }

  .btn-secondary {
    background: #f1f5f9;
    color: #475569;
  }

  .btn-secondary:hover {
    background: #e2e8f0;
  }

  .result-note {
    font-size: 0.875rem;
    color: #94a3b8;
  }

  .spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #e2e8f0;
    border-top-color: #3b82f6;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin: 0 auto 1rem;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
